import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../MuiTable/actions'
import { MuiTableView } from '../components/MuiTable/MuiTableView'

class MuiTable extends Component {
  constructor (props) {
    super(props)
    const { id } = this.props
    this.props.initializeTableState(id)
  }

  componentWillUnmount () {
    this.props.cleanTableState(this.props.id)
  }

  render () {
    const { state } = this.props
    let columns, data, title, titleColor, extraOptions, datosdecimales, fixed2Decimales, isLoading

    if (state) {
      ({ columns, data, title, titleColor = null, extraOptions, fixed2Decimales, isLoading } = state)
      if (fixed2Decimales) {
        datosdecimales = data && data.map(dato => Object.entries(dato).reduce((obj, [clave, valor]) =>
          ({ ...obj, [clave]: typeof (valor) === 'number' ? parseFloat(valor).toFixed(2) : valor }), {}))
      } else { datosdecimales = data }
    }

    return (
      <MuiTableView
        title={title}
        titleColor={titleColor}
        data={datosdecimales}
        columns={columns}
        isLoading={isLoading}
        extraOptions={extraOptions}
      />
    )
  }
}
const mapStateToProps = (state, ownProps) => {
  return {
    state: state.muitable.muiTables[ownProps.id]
  }
}
const withRedux = connect(mapStateToProps, actions)
export default withRedux(MuiTable)
